import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Button } from 'dibs-elements/exports/Button';
import { GridCol } from 'dibs-elements/exports/Grid';
import { MatchmakerIcon } from '../../shared/MatchmakerIcon/MatchmakerIcon';

import { setMatchmakerReferrer } from '../../shared/helpers/matchmakerReferrer';
import styles from './styles/DesignerDirectoryMatchmakerTile.scss';

export const DesignerDirectoryMatchmakerTile: FC = () => {
    return (
        <GridCol
            desktop={4}
            tabletLandscape={6}
            tabletPortrait={6}
            mobile={12}
            dataTn="design-firms-matchmaker-callout"
        >
            <div className={styles.wrapper}>
                <div className={styles.contentWrapper}>
                    <MatchmakerIcon
                        wrapperClass={styles.svgWrapper}
                        personClass={styles.person}
                        professionalClass={styles.professional}
                    />
                    <div className={styles.matchmakerHeader}>
                        <FormattedMessage
                            id="abt.DesignerDirectoryMatchmakerTile.header"
                            defaultMessage="Need help finding the right designer?"
                        />
                    </div>
                    <div className={styles.matchmakerDescription}>
                        <FormattedMessage
                            id="abt.DesignerDirectoryMatchmakerTile.description"
                            defaultMessage="We'll recommend top designers based on your style and needs with our free service."
                        />
                    </div>
                    <div>
                        <Button
                            dataTn="design-firms-try-matchmaker-cta"
                            className={styles.matchmakerCta}
                            size="small"
                            type="secondary"
                            href="/trade/designer-connection/"
                            onClick={() => setMatchmakerReferrer('banner - designer directory')}
                        >
                            <FormattedMessage
                                id="abt.DesignerDirectoryMatchmakerTile.matchmakerCta"
                                defaultMessage="try designer connection"
                            />
                        </Button>
                    </div>
                </div>
            </div>
        </GridCol>
    );
};
